import { Component, OnInit } from '@angular/core';
import { MenuService } from '../menu.service';

declare var jQuery: any;
declare var paceLoad: any;

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {

  constructor(public menuCtrl: MenuService) { }

  ngOnInit() {
    // this.menuCrtl.pageTransOut();
    // paceLoad();
    let el = document.getElementById("nav-toggle");
    let nav = document.getElementById("nav__content");
    let inNav = document.getElementById("sectores-items");
    let sect = document.getElementById("sector");
    let subStatus = false;
    
    sect.onclick = function() {
      subStatus = !subStatus;
      myFunction();
    };

    function myFunction() {
      if (subStatus == true ){
        inNav.style.height = "150px";
      }else{
        inNav.style.height = "0px";
      }

  }
  
  }

}
